"use client";

import { m, useReducedMotion, type Variants } from "motion/react";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { fadeSlideUp } from "@/utils/animation/variants";

interface ScrollRevealProps {
  children: ReactNode;
  variants?: Variants;
  className?: string;
  delay?: number;
  once?: boolean;
  amount?: number | "some" | "all";
  as?: "div" | "section" | "article" | "li" | "span";
}

export function ScrollReveal({
  children,
  variants = fadeSlideUp,
  className,
  delay = 0,
  once = true,
  amount = 0.2,
  as = "div",
}: ScrollRevealProps) {
  const prefersReducedMotion = useReducedMotion();
  const pathname = usePathname();

  // Return static content for users who prefer reduced motion
  if (prefersReducedMotion) {
    const Component = as;
    return <Component className={className}>{children}</Component>;
  }

  const MotionComponent = m[as];

  return (
    <MotionComponent
      key={pathname}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount }}
      variants={variants}
      className={className}
      transition={{ delay }}
    >
      {children}
    </MotionComponent>
  );
}
